<template>
  <div>
    <v-container fluid class="py-0">
      <v-row>
        <v-card flat color="transparent" class="mx-auto py-12 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("news.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">NEWS</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row v-for="item in currentNews" :key="item.title">
        <v-spacer></v-spacer>
          <tci-news-div :imgSrc="item.imgUrl" :title="item.title" :content="item.content" :newsDate="item.newsDate" :jumpTo="item.jumpTo"></tci-news-div>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
          <v-btn v-for="newsYear in newsYears" :key="newsYear" color="grey darken-1" outlined tile class="px-12 mx-6 mb-2" @click='change(newsYear)'>{{ newsYear }}新闻</v-btn>
          <!-- <v-btn color="grey darken-1" outlined tile class="px-12 mx-6 mb-2">2019新闻</v-btn>
          <v-btn color="grey darken-1" outlined tile class="px-12 mx-6 mb-2">2018新闻之前</v-btn> -->
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciNewsDiv from "@/components/TciNewsDiv.vue";
import axios from "axios";
import i18n from '@/i18n';

export default {
  name: "CompanyNews",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-news-div": TciNewsDiv
  },
  data: () => ({
    news:[],
    currentYear:'2020'
  }),
  methods: {
    change: function(year){
      this.currentYear = year;
    }
  },
  computed: {
    currentNews: function() {
      var filterYear;
      var currentNews = this.news[this.news.length-1];
      // console.log(currentNews.newsDate);
      if(this.currentYear){
        filterYear = this.currentYear;
      }else{
        filterYear = currentNews.newsDate.substring(0,currentNews.newsDate.indexOf('-'));
      }
      return this.news.filter(function(item){
        if(i18n.locale=='zh'){
          return item.lang=='ZH'&&item.newsDate.indexOf(filterYear)==0;
        }else{
          return item.lang=='JP'&&item.newsDate.indexOf(filterYear)==0;
        }
      });
    },
    newsYears: function() {
      var allYears = [];
      var lastYear = null;
      for (var i = 0; i < this.news.length; i++) { 
        var currentNews = this.news[this.news.length-i-1];
        var newsYear = currentNews.newsDate.substring(0,currentNews.newsDate.indexOf('-'));
        if(newsYear!=lastYear){
          lastYear = newsYear;
          allYears.push(lastYear);
        }
      }
      if(this.currentYear){
          if(this.currentYear==allYears[0]){
              if(allYears.length>3){
                 return [allYears[0],allYears[1],allYears[2]]
              }else{
                return allYears;
              }
          }else if(this.currentYear==allYears[allYears.length-1]){
            if(allYears.length>3){
              return [allYears[allYears.length-3],allYears[allYears.length-2],allYears[allYears.length-1]]
            }else{
              return allYears;
            }
          }else{
            for (var j = 0; j < allYears.length; j++) { 
              if(this.currentYear == allYears[j]){
                return [allYears[j-1],allYears[j],allYears[j+1]];
              }
            }
            return [];
          }
      }else{
        if(allYears.length>3){
          return [allYears[0],allYears[1],allYears[2]]
        }else{
          return allYears;
        }
      }
    }
  },
  mounted () {
      //http://47.97.198.129:8080/api/news/findAll 改成http://tciman.9ban.tech:8080/api/news/findAll改成http://47.114.149.15:8080/api/news/findAll
    axios
      .get('http://47.114.149.15:8080/api/news/findAll')
      .then(response => (this.news = response.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
  }
};
</script>
